import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from './assets/Docrates_Cancersjukhus_RGB_horizontal.png'
import _imports_1 from './assets/Docrates_CancerCenter_RGB_horizontal.png'
import _imports_2 from './assets/DocratesMehilainen_RGB_vaaka.png'
import _imports_3 from '@/assets/close.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("meta", {
  name: "viewport",
  content: "width=device-width"
}, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "status-degraded"
}
const _hoisted_3 = {
  key: 1,
  class: "navbar"
}
const _hoisted_4 = { class: "navbar-left" }
const _hoisted_5 = {
  key: 0,
  class: "pages"
}
const _hoisted_6 = { id: "navi-personal-data-div" }
const _hoisted_7 = { id: "navi-my-documents-div" }
const _hoisted_8 = {
  key: 0,
  class: "navbar-right"
}
const _hoisted_9 = { class: "user-and-language" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { style: {"width":"20px"} }, null, -1)
const _hoisted_11 = { class: "clickable" }
const _hoisted_12 = { class: "clickable" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { id: "hamburger-single-div" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { id: "hamburger-single-div" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { id: "hamburger-single-div" }, null, -1)
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "div-app-content" }
const _hoisted_19 = {
  key: 2,
  id: "hamburger-menu-div"
}
const _hoisted_20 = { class: "hamburger-menu" }
const _hoisted_21 = { id: "hamburger-menu-close" }
const _hoisted_22 = { id: "hamburger-menu-functions" }
const _hoisted_23 = { id: "navi-personal-data-div" }
const _hoisted_24 = { id: "navi-my-documents-div" }
const _hoisted_25 = { class: "clickable" }
const _hoisted_26 = { class: "clickable" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LanguageSelector = _resolveComponent("LanguageSelector")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.statusBarVisible())
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("b", null, _toDisplayString(_ctx.getStatusTitle) + ":", 1),
          _createTextVNode(" " + _toDisplayString(_ctx.getStatusDescription), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.navBarVisible())
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "logo clickable to-main-view",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toServiceCategories && _ctx.toServiceCategories(...args)))
            }, [
              (_ctx.getSelectedLanguage === 'sv')
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    id: "docrates",
                    style: _normalizeStyle(_ctx.getNaviLogoSelectionStyle()),
                    src: _imports_0,
                    alt: "Docrates Cancer Sjukhuset"
                  }, null, 4))
                : (_ctx.getSelectedLanguage === 'en')
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      id: "docrates",
                      style: _normalizeStyle(_ctx.getNaviLogoSelectionStyle()),
                      src: _imports_1,
                      alt: "Docrates Cancer Center"
                    }, null, 4))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 2,
                      id: "docrates",
                      style: _normalizeStyle(_ctx.getNaviLogoSelectionStyle()),
                      src: _imports_2,
                      alt: "Docrates Syöpäsairaala"
                    }, null, 4))
            ]),
            (_ctx.isLoggedIn() && _ctx.isNavigationButtonsVisible())
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", {
                    style: _normalizeStyle(_ctx.getNaviTabSelectionStyle(_ctx.TABS.Reservations)),
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toReservations && _ctx.toReservations(...args))),
                    id: "navi-bar-reservations"
                  }, [
                    _createElementVNode("h4", {
                      style: _normalizeStyle(_ctx.getNaviTabTextSelectionStyle(_ctx.TABS.Reservations)),
                      class: "clickable"
                    }, _toDisplayString(_ctx.store.getters.translate("generic-reservations")), 5)
                  ], 4),
                  (_ctx.otherServicesMenuVisible)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        style: _normalizeStyle(_ctx.getNaviTabSelectionStyle(_ctx.TABS.OtherServices)),
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toOtherServices && _ctx.toOtherServices(...args))),
                        id: "navi-bar-other-services"
                      }, [
                        _createElementVNode("h4", {
                          style: _normalizeStyle(_ctx.getNaviTabTextSelectionStyle(_ctx.TABS.OtherServices)),
                          class: "clickable"
                        }, _toDisplayString(_ctx.store.getters.translate("other-services")), 5)
                      ], 4))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    style: _normalizeStyle(_ctx.getNaviTabSelectionStyle(_ctx.TABS.PersonalData)),
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toPersonalData && _ctx.toPersonalData(...args))),
                    id: "navi-bar-personal-data"
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("h4", {
                        style: _normalizeStyle(_ctx.getNaviTabTextSelectionStyle(_ctx.TABS.PersonalData)),
                        class: "clickable"
                      }, _toDisplayString(_ctx.store.getters.translate("personal-data")), 5),
                      (_ctx.store.getters.getMissingPatientForm.length > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            id: "div-navi-dot",
                            style: _normalizeStyle(_ctx.getNaviTabDotSelectionStyle(_ctx.TABS.PersonalData))
                          }, null, 4))
                        : _createCommentVNode("", true)
                    ])
                  ], 4),
                  (_ctx.myDocumentsMenuVisible)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        style: _normalizeStyle(_ctx.getNaviTabSelectionStyle(_ctx.TABS.MyDocuments)),
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toMyDocuments && _ctx.toMyDocuments(...args))),
                        id: "navi-bar-my-documents"
                      }, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("h4", {
                            style: _normalizeStyle(_ctx.getNaviTabTextSelectionStyle(_ctx.TABS.MyDocuments)),
                            class: "clickable"
                          }, _toDisplayString(_ctx.store.getters.translate("files")), 5)
                        ])
                      ], 4))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.store.getters.localeSelected)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_LanguageSelector),
                  _hoisted_10,
                  (_ctx.isLoggedIn() && !_ctx.menuOpen)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                        id: "navi-bar-logout"
                      }, [
                        _createElementVNode("h4", _hoisted_11, _toDisplayString(_ctx.store.getters.translate("generic-logout")), 1)
                      ]))
                    : (!_ctx.menuOpen)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          id: "navi-bar-login",
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
                        }, [
                          _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.store.getters.translate("generic-login")), 1)
                        ]))
                      : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    id: "hamburger-div",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.menuOpen = !_ctx.menuOpen))
                  }, _hoisted_16)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("input", {
            type: "hidden",
            id: "locale-debug",
            value: _ctx.localeStr
          }, null, 8, _hoisted_17)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_router_view)
    ]),
    (_ctx.menuOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", {
            class: "hamburger-menu-background",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.menuOpen = false))
          }),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("img", {
                class: "close",
                src: _imports_3,
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.menuOpen = false)),
                alt: "Close"
              })
            ]),
            _createElementVNode("div", _hoisted_22, [
              (_ctx.isLoggedIn() && _ctx.isNavigationButtonsVisible())
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    style: _normalizeStyle(_ctx.getNaviTabSelectionStyle(_ctx.TABS.Reservations)),
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.toReservations && _ctx.toReservations(...args))),
                    id: "navi-bar-menu-reservations"
                  }, [
                    _createElementVNode("h4", {
                      style: _normalizeStyle(_ctx.getNaviTabTextSelectionStyle(_ctx.TABS.Reservations)),
                      class: "clickable"
                    }, _toDisplayString(_ctx.store.getters.translate("generic-reservations")), 5)
                  ], 4))
                : _createCommentVNode("", true),
              (
            _ctx.isLoggedIn() &&
              _ctx.isNavigationButtonsVisible() &&
              _ctx.otherServicesMenuVisible
          )
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    style: _normalizeStyle(_ctx.getNaviTabSelectionStyle(_ctx.TABS.OtherServices)),
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.toOtherServices && _ctx.toOtherServices(...args))),
                    id: "navi-bar-menu-other-services"
                  }, [
                    _createElementVNode("h4", {
                      style: _normalizeStyle(_ctx.getNaviTabTextSelectionStyle(_ctx.TABS.OtherServices)),
                      class: "clickable"
                    }, _toDisplayString(_ctx.store.getters.translate("other-services")), 5)
                  ], 4))
                : _createCommentVNode("", true),
              (_ctx.isLoggedIn() && _ctx.isNavigationButtonsVisible())
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    style: _normalizeStyle(_ctx.getNaviTabSelectionStyle(_ctx.TABS.PersonalData)),
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.toPersonalData && _ctx.toPersonalData(...args))),
                    id: "navi-bar-menu-personal-data"
                  }, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("h4", {
                        style: _normalizeStyle(_ctx.getNaviTabTextSelectionStyle(_ctx.TABS.PersonalData)),
                        class: "clickable"
                      }, _toDisplayString(_ctx.store.getters.translate("personal-data")), 5),
                      (
                !_ctx.store.getters.getAnamnesisTimestamp ||
                  !_ctx.store.getters.getSignicatAuthorizationsTimestamp ||
                  !_ctx.store.getters.getTreatmentHistoryTimestamp
              )
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            id: "div-navi-dot",
                            style: _normalizeStyle(_ctx.getNaviTabDotSelectionStyle(_ctx.TABS.PersonalData))
                          }, null, 4))
                        : _createCommentVNode("", true)
                    ])
                  ], 4))
                : _createCommentVNode("", true),
              (
            _ctx.isLoggedIn() &&
              _ctx.isNavigationButtonsVisible() &&
              _ctx.myDocumentsMenuVisible
          )
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    style: _normalizeStyle(_ctx.getNaviTabSelectionStyle(_ctx.TABS.MyDocuments)),
                    onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.toMyDocuments && _ctx.toMyDocuments(...args))),
                    id: "navi-bar-menu-my-documents"
                  }, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("h4", {
                        style: _normalizeStyle(_ctx.getNaviTabTextSelectionStyle(_ctx.TABS.MyDocuments)),
                        class: "clickable"
                      }, _toDisplayString(_ctx.store.getters.translate("files")), 5)
                    ])
                  ], 4))
                : _createCommentVNode("", true),
              (_ctx.isLoggedIn())
                ? (_openBlock(), _createElementBlock("div", {
                    key: 4,
                    onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                    id: "navi-bar-logout"
                  }, [
                    _createElementVNode("h4", _hoisted_25, _toDisplayString(_ctx.store.getters.translate("generic-logout")), 1)
                  ]))
                : (_ctx.store.getters.localeSelected)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 5,
                      id: "navi-bar-login",
                      onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
                    }, [
                      _createElementVNode("h4", _hoisted_26, _toDisplayString(_ctx.store.getters.translate("generic-login")), 1)
                    ]))
                  : _createCommentVNode("", true),
              _createVNode(_component_LanguageSelector)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}